'use client';
import React, { useState } from 'react';
import Image from 'next/image';

import Button from '@/components/ui/Button';
import { useParams, useRouter } from 'next/navigation';
import { defaultLocale } from '@/constants';

const Header = (props) => {
  const { dict } = props;

  const params = useParams();
  const router = useRouter();

  const currentLocale = params.lang || defaultLocale;

  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  const [currentSection, setCurrentSection] = useState('');

  const toggleLanguage = () => {
    setIsLanguageOpen(!isLanguageOpen);
  };

  const languageOptions = [
    { code: 'en', label: 'ENG' },
    { code: 'lv', label: 'LAT' },
  ];

  const headerItems = [
    { label: dict.headerAboutUs, href: '#about' },
    { label: dict.headerQuality, href: '#quality' },
    { label: dict.headerContactUs, href: '#contact' },
  ];

  const currentLanguage = languageOptions.find(
    (lang) => lang.code === currentLocale
  );

  const otherLanguages = languageOptions.filter(
    (lang) => lang.code !== currentLocale
  );

  const handleLanguageChange = (langCode) => {
    if (langCode === defaultLocale) {
      // If the selected language is the default locale, redirect to the root path
      router.push('/');
      return;
    }
    router.push(`/${langCode}`);
    setIsLanguageOpen(false);
  };

  const handleChangeSection = (href) => {
    setCurrentSection(href);
    const section = document.querySelector(href);

    if (section) {
      const yOffset = -100;
      const y =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <header className='sticky top-0 bg-dark-navy backdrop-blur-sm border-b border-gray-600 py-6 px-4 z-50'>
      <div className='max-w-7xl mx-auto flex items-center justify-between'>
        {/* Logo */}
        <div className='flex items-center space-x-2'>
          <Image
            src='./images/img_group_39969_lime_400.svg'
            alt='Green Energy LV Logo'
            width={46}
            height={41}
          />
          <Image
            src='./images/img_group_39981.svg'
            alt='Green Energy LV Text'
            width={125}
            height={41}
          />
        </div>

        {/* Navigation */}
        <nav className='hidden md:flex items-center space-x-8'>
          {headerItems.map((item) =>
            item.href === currentSection ? (
              <div key={item.href} className='bg-gray-600 rounded-lg px-7 py-4'>
                <span className='text-lg font-montserrat font-semibold text-white'>
                  {item.label}
                </span>
              </div>
            ) : (
              <span
                key={item.href}
                onClick={() => handleChangeSection(item.href)}
                className='text-lg font-montserrat font-medium text-gray-300 hover:text-white transition-colors cursor-pointer'
              >
                {item.label}
              </span>
            )
          )}
        </nav>

        {/* Language and CTA */}
        <div className='flex items-center space-x-6'>
          <div className='relative'>
            <button
              onClick={toggleLanguage}
              className='flex items-center space-x-2 text-lg font-montserrat font-medium text-white'
            >
              <span>{currentLanguage.label}</span>
              <Image
                src='./images/img_vector.svg'
                alt='Dropdown'
                width={11}
                height={5}
              />
            </button>

            {isLanguageOpen && (
              <div className='absolute z-10 top-full mt-2 bg-gray-800 rounded-lg py-2 px-4 min-w-[80px]'>
                {otherLanguages.map((lang) => (
                  <button
                    key={lang.code}
                    // href={`/${lang.code}`}
                    className='block w-full text-left text-white hover:text-lime-400 py-2'
                    onClick={() => handleLanguageChange(lang.code)}
                  >
                    {lang.label}
                  </button>
                ))}
              </div>
            )}
          </div>

          <Button
            className='bg-lime-400 text-gray-800 font-montserrat font-medium px-6 py-4 rounded-lg hover:bg-lime-300 transition-colors'
            onClick={() => handleChangeSection('#contact')}
          >
            {dict.headerButton}
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
